// Compiled using marko@4.28.10 - DO NOT EDIT
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry = require("marko/dist/runtime/components/registry"),
    marko_registerComponent = components_registry.r,
    marko_componentType = marko_registerComponent("/wetracker$1.0.0/src/components/effects_editor/templates/effects_editor.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    marko_attrs0 = {
        "class": "effects-editor"
      },
    marko_attrs1 = {
        "class": "effects-list"
      },
    marko_attrs2 = {
        id: "effects-location",
        "class": "effects-location"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("bbb371"),
    marko_node0 = marko_createElement("div", {
        id: "effects-chain",
        "class": "effects-chain"
      }, "6", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs3 = {
        "class": "location-name"
      },
    marko_node1 = marko_createElement("div", {
        "class": "location-controls"
      }, "5", null, 0, 0, {
        i: marko_const_nextId()
      });

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  out.be("div", marko_attrs1, "1", component);

  var $for$0 = 0;

  marko_forOf(data.effects, function(effect, index) {
    var $keyScope$0 = "[" + (($for$0++) + "]");

    out.e("div", {
        "class": "effect-name",
        "data-fxindex": "" + index
      }, "2" + $keyScope$0, component, 1)
      .t(effect.name, component);
  });

  out.ee();

  out.e("div", marko_attrs2, "3", component, 2)
    .e("div", marko_attrs3, "4", component, 1)
      .t(data.trackname, component)
    .n(marko_node1, component);

  out.n(marko_node0, component);

  out.ee();
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
